import { ApplyPlanAlignmentToPoint } from "./types";

export const applyPlanAlignmentToPoint: ApplyPlanAlignmentToPoint = ({
  point,
  planAlignment,
}) => {
  const scaledX = point.x * planAlignment.scale;
  const scaledY = point.y * planAlignment.scale;

  const rotationDeg = planAlignment.rotation ?? 0;
  const theta = (rotationDeg * Math.PI) / 180;

  const cosT = Math.cos(theta);
  const sinT = Math.sin(theta);

  const rotatedX = scaledX * cosT - scaledY * sinT;
  const rotatedY = scaledX * sinT + scaledY * cosT;

  // Translate + flip Y for render/SVG coordinate system
  return {
    x: rotatedX + planAlignment.offsetX,
    y: -rotatedY + planAlignment.offsetY,
  };
};
